<template>
  <div class="container">
    <div class="row">
      <div class="small-12 columns text-center">
        <img src="../../assets/logo-med.png" class="logo" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboard',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../sass/foundation-import';

  .container {
    margin: $global-margin*3 0;
  }

  img.phones {
    margin: rem-calc(20) 0;
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?3b71b4fd